import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { ThemeProvider } from "@mui/material/styles";
import { Container, Paper, Button } from "@mui/material";
import SiemensLogo from "../../assets/images/siemens-logo-petrol.svg";
import ErrorImage from "../../assets/images/Error.svg";
import "./Error404.css";

const useStyles = makeStyles((theme) => ({
  page_header: {
    margin: `20px 0`,
  },
  unauthorized_block: {
    marginTop: `25px`,
    padding: `40px`,
  },
  "error-icon": {
    color: `var(--error-red-bg-dark-color)`,
    height: `5rem !important`,
    width: `5rem !important`,
    background: `var(--transparent)`,
    borderRadius: 0,
  },
  ua_text: {
    margin: `5px 0`,
  },
  back_home: {
    marginTop: `40px`,
  },
}));

export default function Error() {
  const classes = useStyles();
  return (
    <Container maxWidth={"sm"}>
      <header className={classes.page_header}>
        <Link to="/">
          <img src={SiemensLogo} className="official-logo" alt="Siemens Logo" />
        </Link>
      </header>
      <Paper className={classes.unauthorized_block}>
        {/*<Grid className="d-flex jc-center"><CancelIcon className={classes["error-icon"]} /></Grid>*/}
        {/*<h1 className="d-flex jc-center">ERROR 404</h1>*/}
        <img src={ErrorImage} alt="Error 404" className="error-image" />
        <p className={classes.ua_text}>
          Seems that you have landed on a wrong page.
        </p>
        <p className={classes.ua_text}>Check the URL and try again</p>
        <div className={classes.back_home}>
          <Link to="/">
            <Button className="besys-button--secondary">Go back Home</Button>
          </Link>
        </div>
      </Paper>
    </Container>
  );
}
